import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type CakeIconProps = CreateIconComponentProps;
export const CakeIcon: React.FC<CakeIconProps> = ({
  title = 'Cake',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M7 22h10M4 17.5h16M13 18c.234.781.169 1.244.5 2 .4.914 1.5 2 1.5 2M11 18c-.234.781-.169 1.244-.5 2-.4.914-1.5 2-1.5 2M19 17v-4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v4M18 12V8a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v4"
    />
    <path
      fill="currentColor"
      d="M14.648 5.452a.8.8 0 1 0-1.126-1.137l1.126 1.137Zm-2.646 1.493-.563.569a.8.8 0 0 0 1.126 0l-.563-.569Zm-1.519-2.63a.8.8 0 0 0-1.126 1.137l1.126-1.137Zm-1.12 1.141a.8.8 0 1 0 1.115-1.146L9.362 5.456Zm2.64-2.396-.643.477a.8.8 0 0 0 1.282.004l-.64-.48Zm1.52 1.254a.8.8 0 0 0 1.122 1.141l-1.121-1.141Zm-.001 0L11.44 6.378l1.125 1.137 2.083-2.062-1.126-1.137Zm-.957 2.063-2.082-2.062-1.126 1.137 2.083 2.062 1.125-1.137ZM10.478 4.31a.588.588 0 0 1-.151-.596l-1.528-.475a2.188 2.188 0 0 0 .563 2.217l1.116-1.146Zm-.151-.596a.588.588 0 0 1 .462-.406l-.268-1.577A2.188 2.188 0 0 0 8.799 3.24l1.528.475Zm.462-.406a.588.588 0 0 1 .571.23l1.284-.955a2.188 2.188 0 0 0-2.123-.852l.268 1.577Zm1.853.233a.588.588 0 0 1 .57-.226l.272-1.577a2.188 2.188 0 0 0-2.121.841l1.279.962Zm.57-.226a.588.588 0 0 1 .461.404l1.527-.477a2.188 2.188 0 0 0-1.716-1.504l-.272 1.577Zm.461.404c.066.21.008.44-.15.595l1.122 1.141c.586-.575.8-1.43.556-2.213l-1.528.477Z"
    />
  </CreateIconComponent>
);
